import { format } from 'date-fns';
import { useGetSupportsMutation } from '../../../../redux/apis/supportApi';
import s from './Chats.module.scss';
import { DateFormat } from 'utils/enums/common.enum';
import { ReactComponent as NotRegisteredIcon } from '../../../../assets/icons/close.svg';
import {ReactComponent as RegisteredIcon} from "../../../../assets/icons/completed.svg";
import {ReactComponent as ReadIcon} from "../../../../assets/icons/read.svg";
import {ReactComponent as UnreadIcon} from "../../../../assets/icons/unread.svg";
import { useWebSocket } from '../../../../redux/socket/WebSocket';
import { useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { Skeleton } from 'components/Skeleton/Skeleton';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MessageItem } from './compoents/MessageItem/MessageItem';
import { Chat } from '../Chat/Chat';

export const Chats = () => {

    // ### State
    const [onlineUsers, setOnlineUsers] = useState<any>()
    const [supports, setSupports] = useState<any>([])
    const [unreadSupports, setUnreadSupports] = useState<any>([])
    const [currentSupport, setCurrentSupport] = useState<any>()
    const [firstLoad, setFirstLoad] = useState<boolean>(false)

    const {socket} = useWebSocket()
    
    const userData = localStorage.getItem('userData')
        ? JSON.parse(localStorage.getItem('userData')!)
        : null;
    
    const [GetSupports, {isLoading: isGetSupportsLoading}] = useGetSupportsMutation()
    
    // ### Effects

    useEffect(()=>{
        if(!currentSupport && supports?.length){
            if(localStorage.getItem('currentSupport')){
                const support = supports.find((support: any) => support.supportId === localStorage.getItem('currentSupport'))
                if(support) setCurrentSupport(support)
                    else setCurrentSupport(supports[0])
            } else setCurrentSupport(supports[0])
        }
    },[currentSupport, supports]);

    useEffect(()=>{
        handleGetSupports({currentSupport})
    },[]);

    useEffect(() => {
        socket?.emit("get_online_users");

        const interval = setInterval(() => {
            socket?.emit("get_online_users");
        }, 3000);

        const onlineUsersHandler = (data: any) => {
            if (data?.length) setOnlineUsers(data);
        };

        const handleUpdateHandler = () => {
            handleGetSupports({ currentSupport });
        };
        
        socket?.on('online_users', onlineUsersHandler);
        socket?.on('handle_update_supports', handleUpdateHandler);
        socket?.on('update_messages', handleUpdateHandler);

        return () => {
            clearInterval(interval);
            socket?.off('online_users', onlineUsersHandler);
            socket?.off('handle_update_supports', handleUpdateHandler);
            socket?.off('update_messages', handleUpdateHandler);
        };
    }, [currentSupport]);

    // ### Functions

    async function handleGetSupports({currentSupport}: any){
        setFirstLoad(true)
        const response = await GetSupports({})
        if(response?.data) {

            const sortedSupports = response?.data?.reduce((acc: any, support: any) => {
                const lastMessage = support.messages?.[support.messages?.length - 1]
                const unreadMessages = support?.messages?.filter((message: any) => {
                    if(message.status === 0 && (lastMessage?.name !== userData?.info?.name && message?.status === 0)){
                        acc.unreadIds.add(message.id)
                        acc.unreadIdsSup.add(support.id)
                        return true
                    }
                })
                if(unreadMessages?.length){
                    acc.unreadSupports.push({
                        ...support,
                        unreadLength: unreadMessages?.length
                    })
                }
                else acc.readSupports.push(support)
                return acc
            }, {unreadSupports: [], readSupports: [], unreadIds: new Set([]), unreadIdsSup: new Set([])})
            
            setSupports(sortedSupports.readSupports?.sort((a: any, b: any) => {
                const lastMessageA = a.messages[a.messages.length - 1]
                const lastMessageB = b.messages[b.messages.length - 1]
                return new Date(lastMessageB.date).getTime() - new Date(lastMessageA.date).getTime()
            }))
            
            setUnreadSupports(sortedSupports.unreadSupports?.sort((a: any, b: any) => {
                const lastMessageA = a.messages[a.messages.length - 1]
                const lastMessageB = b.messages[b.messages.length - 1]
                return new Date(lastMessageB.date).getTime() - new Date(lastMessageA.date).getTime()
            }))

            const support = response?.data?.find((el: any) => el.id === currentSupport?.id)
            if(support) setCurrentSupport(support)
        }
    }

    // ### Views
    const supportViews = useMemo(() => { return supports?.map((support: any, index: number) => {
        const message = support?.messages?.[support?.messages?.length - 1]
        const online = onlineUsers?.find((user: any) => user.id === Number(support.supportId))
        
        return(
            <MessageItem 
                support={support}
                message={message}
                name={support.name}
                isOnline={online}
                isActive={currentSupport?.supportId === support.supportId}
                setCurrentSupport={setCurrentSupport}
                handleGetSupports={handleGetSupports}
                currentSupport={currentSupport}
            />
        )
    })}, [supports, onlineUsers, currentSupport])

    const unreadSupportViews = useMemo(() => { return unreadSupports?.map((support: any, index: number) => {
        const message = support?.messages?.[support?.messages?.length - 1]
        const online = onlineUsers?.find((user: any) => user.id === Number(support.supportId))
        
        return(
            <MessageItem 
                support={support}
                message={message}
                name={support.name}
                isOnline={online}
                isActive={currentSupport?.supportId === support.supportId}
                setCurrentSupport={setCurrentSupport}
                unreadLength={support?.unreadLength}
                handleGetSupports={handleGetSupports}
                currentSupport={currentSupport}
            />
        )
    })}, [unreadSupports, onlineUsers, currentSupport])

    return(
        <div className={s.wrapper} >
            <div className={s.chats_wrapper}>
                {unreadSupportViews}                
                {supportViews}
            </div>
            
            <div className={s.chat_wrapper}>
                {
                    currentSupport ? 
                    <Chat support={currentSupport}/> 
                    : null
                }
            </div>
            <Skeleton isLoading={(!onlineUsers || (!firstLoad && isGetSupportsLoading))}/>
        </div>
    )
} 